export const maskEmail = email => {
  const str = email.split('');
  const finalArr = [];
  const index = str.indexOf('@');
  str.forEach((item, pos) => {
    pos >= 0 && pos <= index - 4 ? finalArr.push('x') : finalArr.push(str[pos]);
  });
  let finalStr = finalArr.join('');
  if (finalStr.length > 20) {
    finalStr = `${finalStr.substring(0, 7)}...${finalStr.slice(finalStr.length - 13)}`;
  }
  return finalStr;
};

export const maskMobile = mobile => {
  const str = mobile.split('');
  const finalArr = [];
  const len = str.length;
  str.forEach((item, pos) => {
    pos >= 4 && pos <= len - 4 ? finalArr.push('x') : finalArr.push(str[pos]);
  });
  return finalArr.join('');
};

export const get_cookies = function(request) {
  var cookies = {};
  request.headers &&
    request.headers.cookie &&
    request.headers.cookie.split(';').forEach(function(cookie) {
      var parts = cookie.match(/(.*?)=(.*)$/);
      cookies[parts[1].trim()] = (parts[2] || '').trim();
    });
  return cookies;
};

const size = {
  mobileS: '767px',
};

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
};

export const formatNumber = n => {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + 'K';
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + 'M';
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + 'B';
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + 'T';
};

export function numFormatter(num) {
  if (num > 999 && num <= 99999) {
    return (num / 1000).toFixed(1) + ' K';
  } else if (num >= 100000 && num < 1000000) {
    return (num / 100000).toFixed(1) + ' L';
  } else if (num >= 1000000 && num < 10000000) {
    return (num / 100000).toFixed(1) + ' L';
  } else if (num < 999) {
    return num.toFixed(1);
  }
}

export function numberWithCommas(num) {
  return num.toString().split('.')[0].length > 3
    ? num
        .toString()
        .substring(0, num.toString().split('.')[0].length - 3)
        .replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
        ',' +
        num.toString().substring(num.toString().split('.')[0].length - 3)
    : num.toString();
}

export const getQueryString = (field, url) => {
  var href = url ? url : window.location.href;
  var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  return string ? string[1] : null;
};

export const convertFromEpochToDate = (epoch = '') => {
  return epoch ? new Date(epoch).toLocaleDateString('en-US') : '';
};
